export default __webpack_public_path__ + "static/3pg_logo-e1c0f59c32d6265ed485c57b0aa5ea43.svg";